import { VyPaper } from '../../../../../components/new-design/data-display/VyPaper/VyPaper.tsx';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { VyDescriptionTitle } from '../../../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle.tsx';
import { usageItemSummaryStyles } from '../../../../invoices/DynamicInvoiceViewPage/usage-lines-section/components/styles.ts';
import { dynamicInvoiceProductLineItemSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { Status } from '../../../../../components/design/statuses/Status/Status.tsx';
import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined';
import { isNotNullOrUndefined } from '@vy/utils';

type PortalStatCardProps = {
  label: string;
  title: string;
  subTitle: ReactNode;
  icon: ReactNode;
  titleAdornment?: ReactNode;
  onClick?: () => void;
  isOverage?: boolean;
};

export const PortalStatCard: FC<PortalStatCardProps> = ({
  label,
  title,
  subTitle,
  icon,
  titleAdornment,
  isOverage,
  onClick,
}) => {
  return (
    <VyPaper sx={{ padding: '16px 24px', borderRadius: '20px', border: '1px solid #E8EBF2' }}>
      <Stack direction="row" sx={{ alignItems: 'center', gap: '20px' }}>
        <Box
          sx={{
            display: 'flex',
            padding: '24px',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#F5F6FA',
            borderRadius: '15px',
            maxWidth: 'max-content',
          }}
        >
          {icon}
        </Box>
        <Stack>
          <Typography variant="body2" color="textSecondary" sx={{ fontWeight: '500' }}>
            {label}
          </Typography>
          <Stack direction="row" sx={{ alignItems: 'baseline', gap: 1 }}>
            <VyDescriptionTitle
              title={title}
              subTitle={subTitle}
              boldTitle
              cardSx={{
                '& .MuiCardHeader-title': {
                  fontSize: 20,
                },
              }}
            />
            {titleAdornment}
            {isOverage && (
              <Status
                status="ERROR"
                style={usageItemSummaryStyles.overageStatus}
                {...getSelectorAttribute(dynamicInvoiceProductLineItemSelectors.chips.overage)}
              >
                Overage
              </Status>
            )}
          </Stack>
        </Stack>
        {isNotNullOrUndefined(onClick) && (
          <IconButton
            onClick={onClick}
            sx={{
              padding: '10px',
              border: '1px solid #E8EBF2',
              borderRadius: '10px',
              alignSelf: 'flex-start',
              marginLeft: 'auto',
            }}
          >
            <ArrowOutwardOutlinedIcon sx={{ color: '#000' }} />
          </IconButton>
        )}
      </Stack>
    </VyPaper>
  );
};
